export default "__VITE_ASSET__619a5430__"